// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"34":"bb316c81c50a5d4c","888":"0855220b55f18990"}[chunkId] + ".css";
};